import { hasAllValues } from "@/utils/helper-methods";

export const allRoles = ["NP", "SGARHSTARO", "PGARHSTARO", "PG2010", "WPP_ESZLJP_GUIDE", "LSD", "SP", "SLARHSTARO", "MUARHSTARO", "MUTG"];
let userRoles = null

export function setUserRoles(roles) {
    userRoles = roles;
}

export function getUserRoles() {
    return userRoles;
}

export function isInRole(role) {
    return userRoles.includes(role);
}

export function hasFullAccess() {
    if (userRoles == null) {
        return false;
    }
    return hasAllValues(userRoles, allRoles);
}

export function hasFullAccessForRoles(roles) {
    return hasAllValues(roles, allRoles);
}